import { requestGetAvailablePairs } from '../../coins'
import { useEffect, useMemo } from 'react'
import { useRequest } from 'utility-tools/module/requests'

const useGetPairData = (fromCoinDto, toCoinDto, availablePairs) => {
    const { data: pairData, refetch } = useRequest(
        () => requestGetAvailablePairs(false, `${toCoinDto.code}${fromCoinDto.code}`),
        {
            isDisabled: !fromCoinDto.code || !toCoinDto.code,
        },
    )

    const pairName =
        fromCoinDto.code && toCoinDto.code ? `${toCoinDto.code}${fromCoinDto.code}` : ''

    useEffect(() => {
        if (pairName) {
            refetch()
        }
    }, [pairName])

    const changedAvailablePairs = useMemo(
        () => ({
            ...availablePairs,
            allAvailablePairs:
                availablePairs?.allAvailablePairs?.map(pair => ({
                    ...pair,
                    minAmountFrom:
                        pair.name === pairData[0]?.pair ? pairData[0]?.min_deposit_amount : 0,
                    maxAmountFrom:
                        pair.name === pairData[0]?.pair ? pairData[0]?.max_deposit_amount : 0,
                })) || [],
        }),
        [availablePairs, pairData],
    )

    return { changedAvailablePairs }
}

export { useGetPairData }
